import { ContactOutput } from '@/graphql/generated'
import { createContext } from 'react'

export type AddContactFormModalContextProps = {
  closeModal: () => void
  openModal: (contact?: ContactOutput) => void
  contactData: ContactOutput | null
  isOpen: boolean
}

export const AddContactFormModalContext = createContext<AddContactFormModalContextProps | null>(null)
